// Screen 2: Modern Minimalist
import React from 'react';

const ModernWatch = ({ btcPrice, stats }) => {
  return (
    <div style={{
      height: "100vh",
      width: "100vw",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "SF Pro Display, system-ui, sans-serif",
      backgroundColor: "#1a1a1a", // Dark gray
      color: "#ffffff",
      padding: "2vw"
    }}>
      <div style={{ textAlign: "center", maxWidth: "60vw" }}>
        {/* Screen Indicator */}
        <div style={{ 
          fontSize: "1.5vw", 
          color: "#888", 
          marginBottom: "2vh",
          letterSpacing: "2px"
        }}>
          MODERN
        </div>

        {/* Main Price */}
        <div style={{
          fontSize: "10vw",
          fontWeight: "300",
          marginBottom: "3vh",
          color: "#f7931a",
          fontFamily: "SF Pro Display, system-ui, sans-serif"
        }}>
          {btcPrice === null ? "—" : `$${btcPrice.toLocaleString()}`}
        </div>

        {/* Timeframe Grid */}
        {stats && stats.timeframes && (
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "2vw",
            marginBottom: "3vh"
          }}>
            {["1h", "1d", "1w"].map(period => (
              <div key={period} style={{
                backgroundColor: "#2a2a2a",
                borderRadius: "1.2vw",
                padding: "1.5vw",
                textAlign: "center"
              }}>
                <div style={{ color: "#888", fontSize: "1.6vw", marginBottom: "0.5vh" }}>
                  {period.toUpperCase()}
                </div>
                <div style={{
                  color: stats.timeframes[period] && stats.timeframes[period].change >= 0 ? "#4CAF50" : "#f44336",
                  fontSize: "2.2vw",
                  fontWeight: "500"
                }}>
                  {stats.timeframes[period] && stats.timeframes[period].change >= 0 ? "+" : ""}{stats.timeframes[period] && stats.timeframes[period].change || "0.0"}%
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Range Display */}
        {stats && stats.timeframes && (
          <div style={{
            backgroundColor: "#2a2a2a",
            borderRadius: "0.8vw",
            padding: "1.5vw",
            fontSize: "1.8vw",
            color: "#ccc"
          }}>
            24H Range: ${stats.timeframes["1d"] && stats.timeframes["1d"].low && stats.timeframes["1d"].low.toLocaleString() || "0"} - ${stats.timeframes["1d"] && stats.timeframes["1d"].high && stats.timeframes["1d"].high.toLocaleString() || "0"}
          </div>
        )}
      </div>
    </div>
  );
};

export default ModernWatch;



// WEBPACK FOOTER //
// ./src/screens/ModernWatch.js